const hamburger = document.getElementById("menuButton");
const mobileMenu = document.getElementById("mobileNav");
const menuOverlay = document.getElementById("menuOverlay");
const menuClose = document.getElementById("menuCloseButton");

if (hamburger && mobileMenu && menuOverlay) {
  // The drawer is `position: fixed`, so it measures from the viewport and would
  // otherwise start above the header -- under the admin bar, the promo banner,
  // or both. Measuring the header's own top edge covers every combination at
  // once: whatever sits above it is already priced into that number, so the
  // drawer's close button lines up with the hamburger without the drawer
  // knowing what the chrome above it is made of.
  //
  // It has to be measured rather than assumed: the admin bar is `absolute`
  // below 601px so it scrolls away, and the promo banner is optional.
  const syncChromeOffset = (): void => {
    const header = document.getElementById("jsTopBanner");
    const offset = header
      ? Math.max(0, header.getBoundingClientRect().top)
      : 0;

    document.documentElement.style.setProperty(
      "--njamito-chrome-offset",
      `${offset}px`
    );
  };

  const setState = (open: boolean): void => {
    if (open) syncChromeOffset();
    mobileMenu.classList.toggle("active", open);
    menuOverlay.classList.toggle("active", open);
    hamburger.setAttribute("aria-expanded", open ? "true" : "false");
    // Without this the page keeps scrolling behind the drawer. The scrolling
    // element is <html>, so the class goes on both: the CSS locks <html>, and
    // the body class stays for anything else keying off the open state.
    document.body.classList.toggle("mobile-nav-open", open);
    document.documentElement.classList.toggle("mobile-nav-open", open);
  };

  const closeMenu = (): void => setState(false);

  hamburger.setAttribute("aria-controls", "mobileNav");
  hamburger.setAttribute("aria-expanded", "false");

  hamburger.addEventListener("click", () => setState(true));

  menuClose?.addEventListener("click", closeMenu);

  menuOverlay.addEventListener("click", closeMenu);

  // Any menu link closes the drawer, otherwise same-page anchors leave it open
  // over a scroll-locked body.
  mobileMenu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMenu();
  });

  // Resizing up to desktop hides the drawer in CSS; drop the scroll lock too.
  window.addEventListener("resize", () => {
    if (window.innerWidth > 768) closeMenu();
    else syncChromeOffset();
  });

  // The header's top edge moves as the banner and admin bar scroll away, and
  // again when the header goes sticky. The drawer locks scrolling while open,
  // so this only ever runs while it is closed -- it keeps the offset correct
  // for the next open.
  window.addEventListener("scroll", syncChromeOffset, { passive: true });

  syncChromeOffset();
}
